/**
 * Determines which phone call ID to display.
 * Returns URL param ID when coming from a notification, otherwise returns the initial prop ID.
 */
export const getPhoneCallIdToDisplay = (
    urlPhoneCallId: string | null,
    fromNotification: boolean,
    initialPhoneCallId: number,
): number => {
    if (fromNotification && urlPhoneCallId) {
        return Number(urlPhoneCallId);
    }
    return initialPhoneCallId;
};

/**
 * Checks if URL params should be cleaned up when phone call changes.
 * Returns false if URL matches the new phone call (from notification), true otherwise.
 */
export const shouldCleanUpUrlOnPhoneCallChange = (
    urlPhoneCallId: string | null,
    newPhoneCallId: number,
): boolean => {
    if (!urlPhoneCallId) {
        return false;
    }
    return Number(urlPhoneCallId) !== newPhoneCallId;
};
